import utils from '../utils/utils.js'
export default {
  data () {
    return {
      resource: window.resource,
      tipsTrigger: false,
      isLoading: false,
      leavePage: {
        redirect: false,
        pass: [],
        to: ''
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.leavePage.redirect || this.leavePage.pass.some(item => to.path.indexOf(item) > -1)) {
      next()
      return
    }
    next(false)
    setTimeout(() => {
      this.$router.replace(this.leavePage.to)
    }, 0)
  },
  methods: {
    setTempParam: utils.setTempParam,
    getTempParam: utils.getTempParam,
    delayBack: utils.delayBack,
    formatPrice: utils.formatPrice,
    formatPriceNumber: utils.formatPriceNumber,
    showLoading: utils.showLoading,
    hideLoading () {
      this.isLoading = false
      utils.hideLoading()
    },
    showToast: utils.showToast,
    hideToast: utils.hideToast,
    setTitle: utils.setTitle,
    getMonthlyRange: utils.getMonthlyRange,
    hasPropertyDeep: utils.hasPropertyDeep,
    formatTime: utils.formatTime,
    formatDate (number) {
      var date = new Date(number)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      let day = date.getDate()
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + month + '-' + day
    },
    validateKey (key, value) {
      if (typeof value === 'number') {
        value = value.toString()
      }
      if (key && $scheme && $scheme[key]) {
        if (value) {
          if ($scheme[key].regex.test(value.trim())) {
            return {valid: true, msg: ''}
          } else {
            return {valid: false, msg: $scheme[key].tips}
          }
        } else {
          if ($scheme[key].required) {
            return {valid: false, msg: $scheme[key].tips}
          }
        }
      }
      return {valid: true, msg: ''}
    },
    validate (key) {
      return this.tipsTrigger ? this.validateKey(key, this.param[key], $scheme).msg : ''
    },
    validateAll (param) {
      let invalide = Object.keys(param).filter(item => {
        let {valid} = this.validateKey(item, param[item], $scheme)
        return !valid
      })
      if (invalide.length > 0) {
        return this.validateKey(invalide[0], param[invalide[0]], $scheme)
      }
      return {valid: true}
    }
  }
}



// WEBPACK FOOTER //
// ./src/pg/mixin.js